import {
  CommentOutlined,
  DollarOutlined,
  DownOutlined,
  UserDeleteOutlined,
} from "@ant-design/icons";
import { Button, Dropdown, Space } from "antd";

export default function Actions({
  record,
  onViewCost,
  onViewReject,
  onViewEditHistory,
  onCancel,
  onViewChat,
}) {
  const KEY_ACTIONS = {
    VIEW_COST: "view_cost",
    VIEW_REJECT: "view_reject",
    VIEW_EDIT_HISTORY: "view_edit_history",
    VIEW_CHAT: "view_chat",
  };

  const onClick = ({ key }) => {
    switch (key) {
      case KEY_ACTIONS.VIEW_COST:
        onViewCost(record);
        break;
      case KEY_ACTIONS.VIEW_REJECT:
        onViewReject(record);
        break;
      case KEY_ACTIONS.CANCEL:
        onCancel(record);
        break;
      case KEY_ACTIONS.VIEW_CHAT:
        onViewChat(record);
        break;
      case KEY_ACTIONS.VIEW_EDIT_HISTORY:
        onViewEditHistory(record);
        break;
      default:
        break;
    }
  };

  const actions = {
    super_admin: [
      {
        key: KEY_ACTIONS.VIEW_COST,
        label: "Xem chi tiết phí",
        icon: <DollarOutlined />,
      },
      {
        key: KEY_ACTIONS.VIEW_CHAT,
        label: "Xem lịch sử chat",
        icon: <CommentOutlined />,
      },
      {
        key: KEY_ACTIONS.VIEW_REJECT,
        label: "DS tài xế bỏ qua",
        icon: <UserDeleteOutlined />,
        disabled: record.status === "wait-pay" || record.status === "canceled",
      },
    ],
  };

  actions.admin = actions.super_admin;

  return (
    <Dropdown menu={{ items: actions["super_admin"] || [], onClick }}>
      <Button>
        <Space>
          Thao tác
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>
  );
}
